export const contacts = {
  index: {
    search_title: 'お問い合わせ検索',
    contact_date: '問い合わせ日',
    search_input_placeholder_user: '差出人名、または問い合わせコード',
    search_input_placeholder_partner: '差出企業名、または問い合わせコード',
    search_input_category: '問い合わせ内容を選択してください',
    label_search_category: '問い合わせ内容',
    btn_create: '新規お問い合わせはこちら',
    search_place_holder_partner_site: '問い合わせコード'
  },
  back: '一覧へ戻る',
  id: '問い合わせコード',
  answer: '回答',
  buttons: {
    comment: 'コメントする',
    resolve: '解決済みにする',
    unresolve: '解決済み'
  },
  show_all: 'すべて表示',
  not_show_all: '簡略',
  comment: {
    text: 'コメント',
    form_comment: {
      title: 'コメント投稿',
      btn_confirm: '確認画面へ',
      placholer: 'コメントを入力してください',
    },
    form_confirm_comment: {
      title: '最終確認',
      btn_back: '戻る',
      btn_send: '送信する',
    },
    form_completed: {
      title: '完了',
      message: 'コメントの返信が完了しました。',
      btn_back: 'お問い合わせへ戻る',
    },
    form_resolve: {
      title: '下記お問い合わせを解決済みにしますか？',
      btn_resolve: '解決済みにする',
      btn_cancle: '解決済みにせず戻る'
    },
    form_unresolve: {
      title: '下記お問い合わせを未解決にしますか？',
      btn_unresolve: '未解決にする',
      btn_cancle: '未解決にせず戻る'
    }
  },
  form: {
    input_labels: {
      contact_category_id: 'お問い合わせ内容を選択してください',
      content: 'お問い合わせ詳細',
      contact: 'お問い合わせ'
    },
    input_placeholder: {
      contact_category_id: '選択してください',
      content: 'お問い合わせ詳細を入力してください',
    },
    validate: {
      contact_category_id: 'お問合せ内容',
      content: 'お問合せ詳細'
    },
    buttons: {
      confirm: '確認画面へ',
      send: '送信する'
    },
    from: '宛先',
    from_admin: 'ココロヅケ 運営チーム',
    title_confirm: 'お問い合わせ内容 確認'
  },
  mail: {
    send: {
      group_current_input: 'ご入力いただいたメールアドレス宛に認証コードをお送りします。',
      placeholder: 'メールアドレス',
      btn: '認証コードを送る',
    },
    verify: {
      group_current_input: '受信メールをご確認の上、認証コードを入力してください。',
      placeholder: '認証コード',
      btn: '認証へ',
      btn_resend: 'コードを再送する',
    },
    done: {
      group_current_input: 'メールアドレスの登録・変更が完了しました！',
      btn: 'マイページへ',
    },
    popup: {
      title: 'お問い合わせにはメール認証が必須です',
      desc: '本人確認のため、メールアドレスの認証をお願いします。 \n認証が完了すると、お問い合わせをご利用いただけます。',
      btn_redirect: '入力画面へ',
      btn_back: '戻る',
    },
  },
}
